import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HkbkfacilitiesHeadingListComponent } from './hkbkfacilities-heading-list/hkbkfacilities-heading-list.component';
import { HkbkfacilitiesHeadingCreateComponent } from './hkbkfacilities-heading-create/hkbkfacilities-heading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: HkbkfacilitiesHeadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: HkbkfacilitiesHeadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'hkbkfacilities-heading-create/:id',
        component: HkbkfacilitiesHeadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HkbkfacilitiesHeadingRoutingModule { }
